import React from "react";
import '../../assets/css/skeleton.scss'

class List extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        } 
    }

    render() {
        return (
            <div className="skeleton">
                <div style={{width:280,height:22,marginBottom:32}}/>
                <div style={{width:576,height:22,marginBottom:63}}/>
              {!this.props.history &&
                <div style={{width:253,height:132,marginRight:16,marginBottom:16,borderRadius:10,backgroundColor:"#292B2F",float:"left"}}
                     className="table">
                    <div className="middle">
                        <div style={{width:37,height:37,marginRight:17,float:"left"}}/>
                        <div style={{width:156,height:16,marginBottom:5,float:"left"}}/>
                        <div style={{width:65,height:16,marginRight:5,float:"left"}}/>
                        <div style={{width:65,height:16,float:"left"}}/>
                    </div>
                </div> }
              {!this.props.history &&
                <div style={{width:253,height:132,marginRight:16,marginBottom:16,borderRadius:10,backgroundColor:"#292B2F",float:"left"}}
                     className="table">
                    <div className="middle">
                        <div style={{width:37,height:37,marginRight:17,float:"left"}}/>
                        <div style={{width:156,height:16,marginBottom:5,float:"left"}}/>
                        <div style={{width:65,height:16,marginRight:5,float:"left"}}/>
                        <div style={{width:65,height:16,float:"left"}}/>
                    </div>
                </div> }
              {!this.props.history &&
                <div style={{width:253,height:132,borderRadius:10,marginBottom:16,backgroundColor:"#292B2F",float:"left"}}
                     className="table">
                    <div className="middle">
                        <div style={{width:37,height:37,marginRight:17,float:"left"}}/>
                        <div style={{width:156,height:16,marginBottom:5,float:"left"}}/>
                        <div style={{width:65,height:16,marginRight:5,float:"left"}}/>
                        <div style={{width:65,height:16,float:"left"}}/>
                    </div>
                </div>
              }
            </div>
        )
    }
}

export default List;
